import classNames from "classnames";
import { Header } from "components/atoms/Typography";
import CardBody from "components/molecules/Card/CardBody";
import { IncreaseDecreasePercentage } from "components/molecules/Card/CardFunctions";
import { ValueType } from "components/molecules/Card/CardTypes";
import errorFallbackUI from "components/molecules/ErrorFallbackUI.tsx/ErrorFallbackUI";
import { ComponentErrorBoundary } from "components/molecules/ErrorStates";
import { CardNoDataState } from "components/molecules/NoDataState";
import usePlansState from "recoilStore/Building/usePlansState";
import { displayValueWithUnit, getDisplayInfo } from "utils/formatting";
import prepareCostsCardData from "./CostsCard.helper";
import CostsChart from "./CostsChart/CostsChart";

function CostsCard() {
    const { referencePlan, comparedPlan, referencePlanName, comparedPlanName } = usePlansState();

    const { cardBodyData, cardHeaderData, tooltipElement } = prepareCostsCardData(
        referencePlan,
        comparedPlan,
        referencePlanName,
        comparedPlanName
    );

    const { value, displayInfoKey } = cardBodyData.header;
    const { unit, formatFunction } =
        typeof value === "number" ? getDisplayInfo(displayInfoKey, value) : getDisplayInfo(displayInfoKey);

    if (!cardBodyData) return <CardNoDataState title="Costs" />;

    return (
        <div className={classNames("card", "card-with-chart-container")}>
            <ComponentErrorBoundary fallback={errorFallbackUI("cardHeaderError")} originComponent="Card">
                <Header>Costs</Header>
                <div className="card__value-and-percentage">
                    <Header>
                        {displayValueWithUnit(
                            cardHeaderData[0].value,
                            unit,
                            (v: ValueType) => formatFunction(v) ?? String(v)
                        )}
                    </Header>
                    {typeof cardHeaderData[0].increaseDecreasePercentage === "number" && (
                        <IncreaseDecreasePercentage
                            isHeader={true}
                            value={cardHeaderData[0].increaseDecreasePercentage}
                            tooltipElement={tooltipElement}
                        />
                    )}
                </div>
            </ComponentErrorBoundary>
            <ComponentErrorBoundary fallback={errorFallbackUI("cardBodyError")} originComponent="Card">
                <CardBody sections={cardBodyData.sections} />
            </ComponentErrorBoundary>
            <CostsChart />
        </div>
    );
}

export default CostsCard;
